"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitRegistrationButtonClickExternal = void 0;
const analytics_js_1 = __importStar(require("@hh.ru/analytics-js"));
/** Клик на кнопку "Войти в личный кабинет" на флоу регистрации работодателя, клик на кнопку "Подтвердить" в форме ввода кода с почты на флоу регистрации работодателя через Тинькофф */
const submitRegistrationButtonClick = ({ ...analyticsParams } = {}) => analytics_js_1.default.sendHHEventButtonClick("submit_registration", { screenType: "step_4_verification_code", ...analyticsParams });
exports.default = submitRegistrationButtonClick;
/** Клик на кнопку "Войти в личный кабинет" на флоу регистрации работодателя, клик на кнопку "Подтвердить" в форме ввода кода с почты на флоу регистрации работодателя через Тинькофф */
const submitRegistrationButtonClickExternal = () => analytics_js_1.VendorAnalytics.eventToStorage("employer", "click", "sign_in_register");
exports.submitRegistrationButtonClickExternal = submitRegistrationButtonClickExternal;
